import { guardClient } from '../_axios'

/**
 * タスク新規作成
 * [post]/tasks
 */
export type InsertTaskRequest = {
  columnId: string
  companyId?: number
  title: string
  description?: string
  dueDate?: string
  creator: string
  isSecret: boolean
}

export const insertTask = async (request: InsertTaskRequest) => {
  const path = '/tasks'
  const response = await guardClient.post(path, request)
  return response.data
}
